import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output, SimpleChanges, ElementRef, ViewChild, OnChanges, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LastLoggedInUser, DecodedToken } from '@core/models';
import { CategoryModel } from '@core/models/categories';
import { BrandResult, GetProductsQuery, ProductReturnModel, WishlistModel } from '@core/services/api.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { StoreSortComponent } from '@shared/components/store-sort/shared-store-sort.component';

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductsComponent implements OnInit, OnChanges {
    categoryNumber: string;
  categoryText: string;

    @Input() isLoading: boolean;
    @Input() returnUrl: any;
    @Input() products: ProductReturnModel;
    @Input() wishlist: WishlistModel;
    @Input() getProductsQuery: GetProductsQuery;
    @Input() productsCategories: CategoryModel[];
    @Input() searchText: string;
    @Output() getPagedProductsClick = new EventEmitter<GetProductsQuery>();
    @Output() getPagedProductsByBrandClick = new EventEmitter<GetProductsQuery>();
    @Output() AddToCart$ = new EventEmitter<GetProductsQuery>();
    @Input() brands: Observable<BrandResult[]>;
    @Output() getClickedCheckboxCategory = new EventEmitter<GetProductsQuery>();
    @Output() categoryClick = new EventEmitter<CategoryModel>();
    @ViewChild(StoreSortComponent) storeSort: StoreSortComponent

    activeAccordion: string = null;
    toggleAccordion(accordionId: string) {
        this.activeAccordion = (this.activeAccordion === accordionId) ? null : accordionId;
      }

      isGridView: boolean;
      @ViewChild('grid') grid: ElementRef;
      @ViewChild('list') list: ElementRef;
      pageConfig: any;
      ///params
      orderby: string;
      currentPage: any;
      pageNumber: any;
      categoryFilter: string;
      // Sorting dropdown
      pageSize: number = 18; // Set the number of items per page to 18
      sortBy: any;
      formGroup: any;

 constructor(private _route: ActivatedRoute,
    private _router: Router) {
        // Extract the number and text from the button's content
        const buttonText = 'Categories'; // Replace with the actual button's content
        const match = buttonText.match(/\d+/); // Extracts the number from the button's content

        if (match) {
          this.categoryNumber = match[0];
          this.categoryText = buttonText.replace(this.categoryNumber, '').trim();
        } else {
          this.categoryText = buttonText;
        }
      }

    ngOnInit() {
        this.pageConfig = {
            itemsPerPage: 16,
            currentPage: this.currentPage,
            totalItems: 20
        };

        this.updateGridView(true);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.products && !changes.products.firstChange) {
            this.pageConfig.totalItems = this.products?.total;
            this.pageConfig.currentPage = this.products?.currentPage;
            this.pageConfig.itemsPerPage = this.products?.resultsPerPage
            this.storeSort.selectedSize = this.products?.resultsPerPage
        }

        if (changes.searchText && changes.searchText.currentValue) {
            this.storeSort.selectedSortBy = 'Default'
        }
    }

    // Sorting pagination
    pageChanged(event) {
        this.pageConfig.currentPage = event;
        this.getProductsQuery.pageNumber = event;
        this.getPagedProductsClick.emit(this.getProductsQuery);
        this.topFunction();
        this._router.navigate([], {
            relativeTo: this._route,
            queryParams: {
                pageNumber: this.pageConfig.currentPage,

            },
            queryParamsHandling: 'merge',
            skipLocationChange: false

        });



    }

    updateGridView(res: boolean) {
        this.isGridView = res;
        if (this.isGridView && this.grid !== undefined && this.list !== undefined) {
            this.grid.nativeElement.className = "active";
            this.list.nativeElement.className = ""
        }
        if (!this.isGridView && this.grid !== undefined && this.list !== undefined) {
            this.grid.nativeElement.className = "";
            this.list.nativeElement.className = "active"
        }
    }


    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    updateResultsPerPage(size: any) {
        this.getProductsQuery.resultsPerPage = size;
        this.getPagedProductsClick.emit(this.getProductsQuery);
        this._router.navigate([], {
            relativeTo: this._route,
            queryParams: {
                resultsPerPage: this.getProductsQuery.resultsPerPage,
            },
            queryParamsHandling: 'merge',
            skipLocationChange: false

        });
    }

    updateSortBy(selectedSorting) {
        switch (selectedSorting) {
            case "Price ASC":
                this.getProductsQuery.sortBy = 'Price';
                this.getProductsQuery.sortDirection = 'ASC';
                this.getPagedProductsClick.emit(this.getProductsQuery);
                break;
            case "Price DESC":
                this.getProductsQuery.sortBy = 'Price';
                this.getProductsQuery.sortDirection = 'DESC';
                this.getPagedProductsClick.emit(this.getProductsQuery);
                break;
            case "Default":
                this.getProductsQuery.sortBy = 'Default';
                this.getProductsQuery.sortDirection = 'ASC';
                this.getPagedProductsClick.emit(this.getProductsQuery);
                break;
            case "New":
                this.getProductsQuery.newProductsOnly = true;
                this.getPagedProductsClick.emit(this.getProductsQuery);
                break;
        }
        this._router.navigate([], {
            relativeTo: this._route,
            queryParams: {
                sortBy: this.getProductsQuery.sortBy,
                sortDirection: this.getProductsQuery.sortDirection,
            },
            queryParamsHandling: 'merge',
            skipLocationChange: false
        });
    }

    getProductCategory(event: CategoryModel) {
        this.getProductsQuery.subCategory1Filter = event.isSelected ? '' : event.model.subCategory;
        this.getProductsQuery.brandFilter = '';
        this.getProductsQuery.pageNumber = 1;
        this.pageConfig.currentPage = 1;
        this.getPagedProductsClick.emit(this.getProductsQuery);
        this.categoryClick.emit(event);
        this._router.navigate([], {
            relativeTo: this._route,
            queryParams: {
                pageNumber: '1',
                subCategory1Filter: this.getProductsQuery.subCategory1Filter,
            },
            queryParamsHandling: 'merge',
            skipLocationChange: false

        });


    }

    getProductsByBrand(event) {
        this.getProductsQuery.brandFilter = event;
        this.getPagedProductsByBrandClick.emit(this.getProductsQuery);
        this._router.navigate([], {
            relativeTo: this._route,
            queryParams: {
                pageNumber: '1',
                brandFilter: this.getProductsQuery.brandFilter,
            },
            queryParamsHandling: 'merge',
            skipLocationChange: false

        });
    }


    addToCart() {
        this.AddToCart$.emit(this.formGroup.getRawValue().quantity);
    }
}


